var AppDispatcher = require('../dispatcher/AppDispatcher');
var NewsConstants = require('../constants/NewsConstants');
var AppConstants = require('../constants/AppConstants');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('underscore');

var listenerCount = 0;
var CHANGE_EVENT = 'change';

var ad = {
    status: AppConstants.LOAD_NEWS,
    fetched: false,
    data: null
};

var god_izv = {
    status: AppConstants.LOAD_NEWS,
    fetched: false,
    data: null
};

var _adLoaded = function(data) {
    ad.data = JSON.parse(data);
};

var _god_izvLoaded = function(data) {
    god_izv.data = JSON.parse(data);
};

var _isMovieFinished = function(movie) {
    return movie.status !== 1;
};

var _updateMovie = function(receivedMovies) {
    var updated = false;

    movie.data = movie.data.map(function(movie) {
        if (movie.id === receivedMovie.id) {
            updated = true;
            return receivedMovie;
        }
        return movie;
    });
    // filter tournaments
    movie.data = _.filter(movie.data, function(movie) {
        return movie.status === 1 || movie.status === 0;
    });

    if (!updated) {
        movie.data.push(receivedMovie);
        return false;
    }
    if (_isMovieFinished(receivedMovie)) {
        return false;
    }
    return receivedTournament.id;
};

var NewsStore = assign({}, EventEmitter.prototype,{
    emitChange: function(){
        this.emit(CHANGE_EVENT)
    },
    addChangeListener: function(callback){
        listenerCount++;
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAd: function() {
        return ad
    },
    getGod_izv: function() {
        return god_izv;
    }
});

NewsStore.dispatchToken = AppDispatcher.register(function(action){

    var id;
    switch(action.type){

        case NewsConstants.LOAD_AD_LIST:
            ad.status = NewsConstants.LOADING_AD;
            ad.fetched = false;
            break;

        case NewsConstants.LOAD_GOD_IZV_LIST:
            god_izv.status = NewsConstants.LOADING_GOD_IZV;
            god_izv.fetched = false;
            break;

        case NewsConstants.LOAD_AD_SUCCESS:
            ad.status = NewsConstants.LOAD_AD_SUCCESS;
            ad.fetched = true;
            _adLoaded(action.data);
            break;

        case NewsConstants.LOAD_GOD_IZV_SUCCESS:
            god_izv.status = NewsConstants.LOAD_GOD_IZV_SUCCESS;
            god_izv.fetched = true;
            _god_izvLoaded(action.data);
            break;
       /* case MovieConstant.SEARCH_MOVIE_SUCCES:
            movie.status = MovieConstant.SEARCH_MOVIE_SUCCES;
            _moviesLoaded(action.data);
            break;

        case MovieConstant.SEARCH_MOVIE:
            movie.status = MovieConstant.SEARCH_MOVIE;
            break;
        //TOURNAMENT
        case MovieConstant.LOAD_MOVIE:
            movie.status = MovieConstant.LOADING_STATUS;
            movie.fetched = true;
            break;

        case MovieConstant.SEARCH_M_SUCCES:
            movieDetails.status = MovieConstant.SEARCH_M_SUCCES;
            _detailsLoaded(action.data);
            break;


        case MovieConstant.LOAD_MOVIE_SUCCESS:
            movie.status = MovieConstant.LOADED_STATUS;
            _moviesLoaded(action.data);
            break;*/

        default:
        return null;
    }
    NewsStore.emitChange(id);

})

module.exports = NewsStore



/** WEBPACK FOOTER **
 ** ./modules/store/NewsStore.js
 **/